import { Skeleton } from './skeleton/Skeleton';

interface LoadingStateProps {
  ariaLabel?: string;
  className?: string;
  compact?: boolean;
}

export function LoadingState({ ariaLabel = 'Загрузка данных', className = '', compact = false }: LoadingStateProps) {
  const classes = `loading-state workspace-loading${compact ? ' loading-state_compact' : ''} ${className}`;
  return <div aria-label={ariaLabel} className={classes} role="status">
    <div className="skeleton-stack">
      <Skeleton variant="line" className="skeleton_medium" />
      <Skeleton variant="line" />
      {!compact ? <Skeleton variant="line" className="skeleton_short" /> : null}
    </div>
  </div>;
}
